import React from 'react'
import ReactDOM from 'react-dom'

import App from 'App'
import registerServiceWorker from 'registerServiceWorker'

// regular imports
ReactDOM.render(<App />, document.getElementById('root'))

// if (module.hot) {
//   module.hot.accept('./App', () => {
//     ReactDOM.render(<App />, document.getElementById('root'))
//   })
// }

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js